import { GOOGLE_ADS_ID, CONVERSION_LABELS } from "./constants";

const fire = (eventName, labelKey) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", eventName);
  const label = CONVERSION_LABELS[labelKey];
  if (label) {
    window.gtag("event", "conversion", { send_to: `${GOOGLE_ADS_ID}/${label}` });
  }
};

export const trackPhoneClick = () => fire("contact", "phone");
export const trackFormSubmit = () => fire("generate_lead", "form");
